import React, { useState } from 'react';
import './Products.css';

const productsList = [
  { cat: "control", img: "headEndControlUnit.png", tag: "Control", title: "Head End Control Unit", desc: "Primary interface for Conveyor Belt Protection.", 
    modalDesc: "The HECU serves as the primary intelligence hub for Conveyor Belt Protection. It provides remote pre-start warnings, continuous SAFELINE interlock monitoring, and automated winch interlocking mechanisms. Integrated with SCADA, it ensures immediate, hardwired fault response to mechanical anomalies." },
  
  { cat: "comms", img: "HighSpeedFiberOpticCabling.png", tag: "Networking", title: "Fiber Optic Cabling", desc: "Premium multi-core cables with total EMI immunity.", 
    modalDesc: "Industrial-grade armored fiber optic cables designed for ultra-low splice attenuation and total Electromagnetic Interference (EMI) immunity. Ideal for spanning vast mining and manufacturing complexes to create high-bandwidth backbones that never drop packets during electrical surges." },
  
  { cat: "comms", img: "GPONHeadendsamp.png", tag: "Networking", title: "GPON Headends & Switches", desc: "Gigabit Ethernet uplinks and ProSafe PoE switches.", 
    modalDesc: "Gigabit Passive Optical Network (GPON) OLT Headends combined with ProSafe Gigabit Smart PoE switches. This allows for centralized data distribution over expansive areas, powering IP cameras, VOIP phones, and PLCs with uncompromised throughput." },
  
  { cat: "monitoring", img: "EmbeddedDVRamp.png", tag: "Surveillance", title: "Embedded DVR & NVR", desc: "HD cameras with IR night vision and PTZ control.", 
    modalDesc: "Robust visual monitoring solutions featuring wireless and hardwired Network Video Recorders. Integrates seamlessly with IP66-rated HD cameras equipped with IR night vision and PTZ optical zoom for active mechanical oversight in low-visibility environments." },
  
  { cat: "safety", img: "PullSwitchSafetyInterlocksPullkey11000amp.png", tag: "Safety", title: "Pull-Switch Safety Interlocks", desc: "Heavy-duty Scanbelt SAFELINE emergency switches.", 
    modalDesc: "EN ISO 13849-1 compliant Scanbelt SAFELINE IV-R pull-switches. Built with double-failsafe mechanisms, highly visible TRIP/RESET indicators, and slackrope detection to guarantee immediate shutdown upon manual activation along conveyor lengths." },
  
  { cat: "monitoring", img: "SpeedSwitchBSD3000amp.png", tag: "Monitoring", title: "Speed Switch BSD3000", desc: "Tracks rotational speed for belt slip detection.", 
    modalDesc: "A modular, non-contact rotational speed sensor. The BSD3000 monitors continuous angular velocity, triggering automated drive shutdowns if slip, underspeed, or overspeed conditions surpass predefined safety thresholds." },
  
  { cat: "safety", img: "SlackRopeamp.png", tag: "Safety", title: "Slack Rope & Rip Detectors", desc: "Non-contact belt edge damage detection.", 
    modalDesc: "Engineered to detect longitudinal tears in heavy belts. Utilizing a magnetic pull-out pin mechanism housed in an IP66 alloy enclosure, these detectors completely eliminate false trips caused by ambient vibration while ensuring rapid motor cutoff." },
  
  { cat: "control", img: "6996f033b1860f028988f967.png", tag: "Fluid Control", title: "Industrial Valves", desc: "Pressure reducing and double failsafe deluge valves.", 
    modalDesc: "High-pressure fluid control systems featuring 90-FPX pressure-reducing valves and 50B-4KG1 pressure relief systems. Crucial for managing hydro-mechanical integrity in pumping stations and cooling circuits." },
  
  { cat: "monitoring", img: "VaneOilPumpsamp.png", tag: "Fluid Systems", title: "Vane Oil Pumps & Meters", desc: "MVP-370 pumps and LC1 totalizer flow meters.", 
    modalDesc: "Industrial-grade MVP-370 vane oil pumps combined with precise LC1 mechanical totalizer flow meters. Designed for rigorous fluid transfer, lubrication systems, and precise volume metering in harsh environments." },
  
  { cat: "monitoring", img: "LiquidLevelMonitoring.png", tag: "Monitoring", title: "Liquid Level Float Switches", desc: "IP65-rated sensors for tank monitoring.", 
    modalDesc: "Stainless steel float switches (LF-10CEQ, LF-10CEM, FF-70SSS) rated for 250VAC. These rugged sensors provide reliable high/low limit triggers to prevent overflow and dry-run cavitation in industrial vats and tanks." },
  
  { cat: "automation", img: "IndustrialAutomationPLCsamp.png", tag: "Automation", title: "Industrial PLCs & Timers", desc: "Siemens LOGO! 8 PLCs for decentralized logic.", 
    modalDesc: "Decentralized logic control utilizing Siemens LOGO! 8 PLCs with integrated web servers. Combined with ACDC Dynamics modular timers, they allow for flexible, scalable automation of repetitive mechanical processes." },
  
  { cat: "comms", img: "GSMCommanderWirelessTelemetry.png", tag: "Telemetry", title: "GSM Commander", desc: "Wireless telemetry for remote pump stations.", 
    modalDesc: "The V8 GSM Commander enables remote cellular-based telemetry. Ideal for managing isolated pump stations or irrigation networks on 10-24VDC, providing SMS alerts and remote reset capabilities without running miles of cable." },
  
  { cat: "comms", img: "RuggedizedIndustrialTelephonesamp.png", tag: "Comms", title: "Ruggedized Telephones", desc: "Heavy-duty Zenith Z500 & Ratel A120 phones.", 
    modalDesc: "Voice communication hardware built for extreme abuse. Includes the Zenith Z500, Ratel A120, and specialized emergency call points (ECPG003) featuring noise-canceling acoustics for electromagnetically noisy areas." },
  
  { cat: "comms", img: "RadioCommunicationsTransmitterReceiverRepeaterVXR9000E.png", tag: "Radio", title: "Radio Repeater VXR-9000E", desc: "25-Watt reliable radio repeater systems.", 
    modalDesc: "A continuous-duty 25-Watt VHF/UHF radio repeater. It anchors our Leaky Feeder systems underground, ensuring that voice and data communication propagate smoothly through deep tunnels without dead zones." },
  
  { cat: "comms", img: "69709a853c576003507221df.png", tag: "Infrastructure", title: "Scancom Network Gear", desc: "Intellitune and Power Couplers.", 
    modalDesc: "The proprietary backbone of underground leaky feeder networks. The suite includes Intellitune modules, 3/4-Way power couplers, and End-of-Line diagnostics to ensure signal integrity across kilometers of subterranean workings." }
];

const Products = () => {
  const [filter, setFilter] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const filteredProducts = productsList.filter(p => filter === 'all' || p.cat === filter);

  return (
    <section id="products">
      <div className="section-hero">
        <div className="prlx-bg" style={{ backgroundImage: `url('/assets/images/next-era-gen-ai-report-shero-2560x1440.jpeg')` }}></div>
        <div className="prlx-overlay"></div>
        <div className="prlx-overlay-gold"></div>
        <div className="sh-content">
          <div className="sh-label">Product Portfolio</div>
          <h2 className="sh-title">Equipment <em>Catalog</em></h2>
        </div>
      </div>

      <div className="sec products-sec">
        <div className="sec-inner">
          <div className="reveal">
            <div className="sec-label">Comprehensive Stock</div>
            <h2 className="sec-title" style={{ color: '#fff' }}>Industrial <span style={{ color: 'var(--gold)' }}>Equipment</span></h2>
            <div className="divider"></div>
            <p className="sec-desc" style={{ color: 'rgba(255,255,255,.6)' }}>Browse our 15 core equipment categories engineered to integrate seamlessly for site-wide protection and communication.</p>
          </div>

          <div className="prod-tabs">
            {['all', 'control', 'comms', 'safety', 'monitoring', 'automation'].map(tab => (
              <button 
                key={tab} 
                className={`tab-btn ${filter === tab ? 'active' : ''}`}
                onClick={() => setFilter(tab)}
              >
                {tab === 'all' ? 'All Products' : tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          <div className="prod-grid stagger-children">
            {filteredProducts.map((prod) => (
              <div className="prod-card reveal" key={prod.title} onClick={() => setSelectedProduct(prod)}>
                <div className="prod-card-img">
                  <img src={`/assets/images/${prod.img}`} alt={prod.title} />
                  <div className="prod-card-glow"></div>
                </div>
                <div className="prod-card-overlay"><span>View Details</span></div>
                <div className="prod-body">
                  <div className="prod-tag">{prod.tag}</div>
                  <h4>{prod.title}</h4>
                  <p>{prod.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Product Modal */}
        {selectedProduct && (
          <div className="modal-overlay" onClick={() => setSelectedProduct(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setSelectedProduct(null)}>✕</button>
              <div className="sec-label">Product Specification</div>
              <h2 className="sec-title" style={{ fontSize: '28px', marginBottom: '16px' }}>{selectedProduct.title}</h2>
              <div className="prod-tag" style={{ display: 'inline-block', marginBottom: '20px', background: 'var(--navy)', color: '#fff', padding: '4px 10px', borderRadius: '4px' }}>
                {selectedProduct.tag}
              </div>
              <div className="divider" style={{ margin: '0 0 20px 0' }}></div>
              <img 
                src={`/assets/images/${selectedProduct.img}`} 
                alt={selectedProduct.title} 
                style={{ width: '100%', height: '250px', objectFit: 'contain', background: 'var(--off)', borderRadius: '6px', marginBottom: '20px', padding: '10px' }}
              />
              <p style={{ lineHeight: '1.8', color: 'var(--txt)', fontSize: '15px' }}>{selectedProduct.modalDesc}</p>
            </div>
          </div>
        )}

      </div>
    </section>
  );
};

export default Products;